import { getUnifiedCreditsUsageProductNameKey } from './unifiedCreditsUsageProductLabels';

/** Unified my-listings listing-type chip (Elite / Featured / etc.) */
export const UNIFIED_LISTING_TYPE_TAG_LAYOUT = {
  height: 18,
  minHeight: 18,
  maxHeight: 18,
  lineHeight: '18px',
  fontSize: 10,
  display: 'inline-flex',
  alignItems: 'center',
  margin: 0,
  verticalAlign: 'middle',
};

const ELITE_TAG_STYLE = {
  ...UNIFIED_LISTING_TYPE_TAG_LAYOUT,
  background: 'linear-gradient(270deg, #E29D01 0%, #C99602 100%)',
  backgroundImage: 'linear-gradient(270deg, #E29D01 0%, #C99602 100%)',
  backgroundBlendMode: 'normal',
  color: '#ffffff',
  '--tag-color': '#ffffff',
};

const FEATURED_TAG_STYLE = {
  ...UNIFIED_LISTING_TYPE_TAG_LAYOUT,
  background: 'linear-gradient(88.97deg, rgba(20, 114, 236, 0.959574) -1.51%, #4D9FEB 126.44%)',
  backgroundImage: 'linear-gradient(88.97deg, rgba(20, 114, 236, 0.959574) -1.51%, #4D9FEB 126.44%)',
  backgroundBlendMode: 'normal',
  color: '#ffffff',
  '--tag-color': '#ffffff',
};

const BOOST_TO_TOP_TAG_STYLE = {
  ...UNIFIED_LISTING_TYPE_TAG_LAYOUT,
  background: 'linear-gradient(90.12deg, #43BB3F -23.76%, #A1DD9F 158.42%)',
  backgroundImage: 'linear-gradient(90.12deg, #43BB3F -23.76%, #A1DD9F 158.42%)',
  backgroundBlendMode: 'normal',
  color: '#ffffff',
  '--tag-color': '#ffffff',
};

const unifiedTierTagBase = (tagStyle) => ({
  hideIconInTag: true,
  icon: undefined,
  iconProps: undefined,
  tagSpace: '0 6px',
  tagBackgroundColor: 'transparent',
  tagStyle: { ...tagStyle },
});

/**
 * Styling for unified tier chips (listings + credit history): Elite / Featured / Boost to Top gradients, no icon.
 * Other tiers keep tenant ProductTag visuals but use short unified i18n labels where applicable.
 */
export const getUnifiedListingTierProductTagProps = (slug, fallbackTagProps = {}) => {
  const nameKey = getUnifiedCreditsUsageProductNameKey(slug) || fallbackTagProps.name;

  if (slug === 'signature-listing' || slug === 'elite-listing') {
    return {
      ...fallbackTagProps,
      name: nameKey,
      ...unifiedTierTagBase(ELITE_TAG_STYLE),
    };
  }

  if (slug === 'hot-listing' || slug === 'feature') {
    return {
      ...fallbackTagProps,
      name: nameKey,
      ...unifiedTierTagBase(FEATURED_TAG_STYLE),
    };
  }

  if (slug === 'boost-to-top' || slug === 'refresh') {
    return {
      ...fallbackTagProps,
      name: nameKey,
      ...unifiedTierTagBase(BOOST_TO_TOP_TAG_STYLE),
    };
  }

  return {
    ...fallbackTagProps,
    name: nameKey,
    hideIconInTag: true,
    icon: undefined,
    iconProps: undefined,
    tagSpace: '0 6px',
    tagBackgroundColor: fallbackTagProps.iconProps?.color ?? fallbackTagProps.tagBackgroundColor,
    tagStyle: {
      ...UNIFIED_LISTING_TYPE_TAG_LAYOUT,
      backgroundBlendMode: 'normal',
      backgroundImage: 'none',
    },
  };
};
